<template>
  <div class="infobox" :style="parentStyle">
    <template v-show="hasData">
      <ul>
        <li
          v-for="(item, index) in dataChart"
          :key="index"
          :title="item.name + '(' + item.value + ')'"
          :style="getRec(item, index)"
          @click="goLink(item.name, item.value)"
        >
          <span>{{ item.name }}</span>
        </li>
      </ul>
    </template>
    <template v-if="!hasData">
      <empty></empty>
    </template>
  </div>
</template>
<script>
import init from '@/mixins/chart';
export default {
  name: 'rectangle',
  mixins: [init],
  props: {
    option: Object,
    component: Object
  },
  computed: {
    parentStyle() {
      return {
        height: this.component.height + 'px',
        width: this.component.width + 'px',
        fontWeight: this.option.fontWeight || 'normal',
        fontSize: (this.option.fontSize || 40) + 'px',
        color: this.option.color || '#fff',
        textAlign: this.option.titlePostion || 'center',
        lineHeight: this.option.tagLineHeight
      };
    },
    hasData() {
      return this.dataChart.length > 0;
    }
  },
  methods: {
    getRec(item, index) {
      const total = this.dataChart;
      let all = 0;
      total.forEach(function(el) {
        all = all + el.value;
      });
      const rec = all ? (item.value / all) * 100 + '%' : '';
      var r = Math.ceil(Math.random() * 130 + 110);
      var g = Math.ceil(Math.random() * 130 + 110);
      var b = Math.ceil(Math.random() * 130 + 110);
      if (total.length > this.option.barColor.length) {
        return { background: 'rgb(' + r + ',' + g + ',' + b + ')', width: rec };
      } else {
        return {
          background: this.option.barColor[index].color1 || [],
          width: rec
        };
      }
    },
    goLink(n, v) {
      const params = {
        name: n,
        value: v
      };
      this.progressClick(params);
    }
  }
};
</script>
<style lang="scss">
.infobox {
  ul {
    width: 100%;
  }
  li {
    list-style: none;
    float: left;
    height: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
